import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { DeliverableOrMilestoneType } from '@lib/api_ts/continuousReportingApi';
import { getMilestoneByProjectIdAndMilestoneId, MilestoneType, StreamType } from 'lib/api_ts/overviewApi';
import { TaskStatusType, UserForResponsibleType } from 'lib/api_ts/responsibleApi';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom-v5-compat';

interface ContinuousReportingMilestoneUpdateFormProps {
	data: DeliverableOrMilestoneType;
	isModalOpen: boolean;
	streams: StreamType[];
	possibleResponsibles: UserForResponsibleType[];
	taskStatus: TaskStatusType[];
}

const ContinuousReportingMilestoneUpdateForm: React.FC<ContinuousReportingMilestoneUpdateFormProps> = ({
	data,
	isModalOpen,
	streams,
	possibleResponsibles,
	taskStatus,
}) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];
	const [isLoading, setIsLoading] = useState(true);
	const [selectedMilestone, setSelectedMilestone] = useState<MilestoneType>();

	const selectedStream = streams?.find((stream) => stream.id === selectedMilestone?.wpStreamId);

	const responsibleUser = possibleResponsibles?.find((responsible) => responsible.id === selectedMilestone?.responsible);

	const responsibleValue = `${responsibleUser?.firstName} ${responsibleUser?.lastName} (${responsibleUser?.email})`;

	useEffect(() => {
		if (!isModalOpen) return;
		(async () => {
			try {
				const milestoneFromAPi = await getMilestoneByProjectIdAndMilestoneId(projectId, data.id);
				setSelectedMilestone(milestoneFromAPi);
				setIsLoading(false);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		})();
	}, [data.id, data.type, projectId, isModalOpen]);

	const fields = [
		{
			label: 'N. Milestone',
			name: 'number',
			value: selectedMilestone?.number,
		},
		{
			label: 'Titolo',
			name: 'title',
			value: selectedMilestone?.title,
		},
		{
			label: 'Descrizione',
			name: 'description',
			value: selectedMilestone?.description || 'N.D.',
		},
		{
			label: 'WP di riferimento',
			name: 'wpStreamId',
			value: selectedStream ? `${selectedStream.streamId} - ${selectedStream.name}` : '',
			//   value: selectedMilestone?.description || "N.D.",
		},
		{
			label: 'Responsabile',
			name: 'responsible',
			value: responsibleValue,
			//   value: selectedMilestone?.description || "N.D.",
		},
		{
			label: 'Doc. probatoria',
			name: 'documents',
			value: selectedMilestone?.probativeDocumentation,
			//   value: selectedMilestone?.description || "N.D.",
		},
		// {
		// 	label: 'Completata',
		// 	name: 'completed',
		// 	value: selectedMilestone?.status === 'COMP' ? 'SÌ' : 'NO',
		// 	// value: selectedMilestone?.completed ? 'Sì' : 'No',
		// },
		{
			label: 'Status',
			name: 'status',
			value: (() => {
				if (selectedMilestone && taskStatus) {
					const status = taskStatus.find((status) => status.code === selectedMilestone.status);
					return status ? status.name : '';
				}
			})(),
			fullWidth: true,
		},
		{
			label: 'Data prevista',
			name: 'forecastDate',
			value: selectedMilestone?.forecastDate
				? format(selectedMilestone?.forecastDate, 'dd/MM/yyyy', {
					locale: it,
				})
				: '',
		},
		{
			label: 'Data effettiva',
			name: 'effectiveDate',
			value: selectedMilestone?.effectiveDate
				? format(selectedMilestone?.effectiveDate, 'dd/MM/yyyy', {
					locale: it,
				})
				: '',
		},

		...(selectedMilestone?.note
			? [
				{
					label: 'Note',
					name: 'note',
					type: 'text',
					fullWidth: true,
					value: selectedMilestone.note,
				},
			]
			: []),
	];

	//   const renderField = (field: (typeof fields)[number]) => {
	//     switch (field.type) {
	//       case "plainText":
	//         return <Form.Text as="p">{field.value}</Form.Text>;
	//       case "date":
	//       case "text":
	//         return (
	//           <Form.Control
	//             type={field.type}
	//             value={field.value}
	//             className="mb-3"
	//           />
	//         );
	//         case "select":
	//             return <Select />
	//       default:
	//         return null;
	//     }
	//   };

	return isLoading ? (
		<div className="text-center my-4">
			<Spinner animation="border" role="status" />
		</div>
	) : (
		<Form>
			<Row>
				{fields.map((field) => {
					return (
						<Form.Group key={field.name} as={Col} md={field.fullWidth ? 12 : 6} className="pe-2 mb-3" style={{ marginTop: '2rem' }}>
							<Form.Label className="mb-3">{field.label}</Form.Label>
							<Form.Text as="p">{field.value}</Form.Text>
						</Form.Group>
					);
				})}
			</Row>
		</Form>
	);
};

export default ContinuousReportingMilestoneUpdateForm;
